import React from 'react';
import { useNavigate } from 'react-router-dom';

function DuyurularPage() {
  const navigate = useNavigate();

  const duyurular = [
    {
      title: "Ecogreen Enerji Holding A.Ş. Fiyat Tespit Raporu'na İlişkin Analist Raporu",
      description: "Fiyat Tespit Raporuna aşağıdaki linkten ulaşabilirsiniz.",
      date: "22.10.2025 17:16"
    },
    {
      title: "Nazilli İrtibat Bürosu Kapatılmasına & Birleşmesine İlişkin Duyuru",
      description: "Şirketimizin 20.06.2025 tarihli Yönetim Kurulu Kararı ile...",
      date: "08.07.2025 12:14"
    },
    {
      title: "Kredili İşlemlere Konu Edilemeyecek Hisse Senetleri Hk.",
      description: "",
      date: "28.05.2025 19:19"
    },
    {
      title: "Manisa İrtibat Bürosu Kapatılmasına&Birleşmesine İlişkin Duyuru",
      description: "Şirketimizin 25.04.2025 tarihli Yönetim Kurulu Kararı",
      date: "12.05.2025 10:37"
    },
    {
      title: "Whatsapp Programı ve E-posta Üzerinden Alınan Emirler Hakkında Duyuru",
      description: "SPK tarafından 2020 yılında pandemi koşulları nedeniyle Whatsapp programı ve e-posta üzerinden emir kabul edilmesine…",
      date: "30.12.2024 15:52"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-[#1e5a8e] py-6 px-4 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="text-white hover:text-[#26c6da] transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-white">Duyurular</h1>
          <div className="w-6"></div>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-5xl mx-auto py-12 px-4">
        <div className="space-y-6">
          {duyurular.map((duyuru, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <h2 className="text-xl md:text-2xl font-bold text-[#1e5a8e] mb-3">
                {duyuru.title}
              </h2>
              {duyuru.description && (
                <p className="text-gray-600 mb-4">{duyuru.description}</p>
              )}
              <p className="text-gray-400 text-sm">{duyuru.date}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DuyurularPage;
